import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Hero from "@/components/home/Hero";
import { Overview, Amenities, HowItWorks } from "@/components/home/Sections";
import Gallery from "@/components/home/Gallery";
import Plans from "@/components/home/Plans";
import Availability from "@/components/home/Availability";
import { Location, Faq, ContactSection } from "@/components/home/More";
import OurStory from "@/components/home/Story";

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView(), 300);
    }
  }, []);
  return (
    <div className="min-h-screen bg-[#08080a]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Gallery />
        <Amenities />
        <Plans />
        <Availability />
        <HowItWorks />
        <Location />
        <Faq />
        <ContactSection />
        <OurStory />
      </main>
      <Footer />
    </div>
  );
}
